function insertRedirecterScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
    } else {
      const el = document.createElement('script');

      el.type = 'text/javascript';
      el.async = true;
      el.src = src;

      el.addEventListener('load', resolve);
      el.addEventListener('error', reject);
      el.addEventListener('abort', reject);

      document.head.appendChild(el);
    }
  });
}

function getMetaData(url) {
  return new Promise((resolve, reject) => {
    insertRedirecterScript(url)
      .then(() => {
        resolve(window.metadata);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export default getMetaData;
